<link rel='stylesheet prefetch'
  href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.2/css/font-awesome.min.css'>

<div class="mb-im-large">
  <div class="col-sm-8 col-sm-offset-2">
    <div class="col-sm-6 col-xs-12 mb-audio-sec">
      <div class="mb-audio-sec-outter">
        <div class="mb-audio-profile-pic mb-audio-profile-left">
          <img *ngIf="session.me.profileImage == null" src="/images/ucsession1.jpg">
          <img *ngIf="session.me.profileImage != null" [src]="session.me.profileImage">
        </div>
        <div class="mb-audio-name">{{session.me.name}}</div>
        <div class="mb-audio-control">
          <div>
            <div id="you-audio-wrapper">
              <div id="me-audio">
              </div>
            </div>
            <div class="mb-video-control">
              <button type="button" [className]="isMuted ? 'mb-video-control-unmute' : 'mb-video-control-mute'"
                (click)="toggleMute()"></button>
              <button type="button" class="mb-video-control-stop" (click)="endSession()"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-xs-12 mb-audio-sec">
      <div class="mb-audio-sec-outter">
        <div class="mb-audio-profile-pic mb-audio-profile-right">
          <img *ngIf="session.otherParty.profileImage == null" src="/images/ucsession1.jpg">
          <img *ngIf="session.otherParty.profileImage != null" [src]="session.otherParty.profileImage">
        </div>
        <div class="mb-audio-name">{{session.otherParty.name}}</div>
        <div class="mb-audio-control">
          <div id="you-audio"></div>
          <div class="mb-video-control">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="clear"></div>
</div>
